export default {
  name: "arrow_asc",
  box: 24,
  svg: `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7l4-4m0 0l4 4m-4-4v18" stroke="fillcolor"/>`,
};
